<style scoped lang="scss">
.breads{
  overflow:auto;line-height: 48px;margin-bottom:  20px;
}
.desc{
  font-size: 16px;text-indent: 0;
}
.compose-type{
    background: #f6fafd;
    padding-bottom: 80px;
    margin-top: 100px;
}
@media screen and (max-width: 640px) {
  .compose-type {
    margin-top: 50px;
    padding-bottom: 30px;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <!--  基因合成-定点突变 -->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <!-- banner -->
    <gene-top-banner :smallTitle="smallTitle" :bigTitle="bigTitle"></gene-top-banner>
    <section v-if="!$route.meta.invisibles">
      <!-- 导航 -->
      <div class="breads container">
        <bread></bread>
      </div>
      <!-- 概述 -->
      <div class="container">
        <p class="desc mb20">定点突变是指通过聚合酶链式反应（PCR）等方法向目的DNA片段（基因组或质粒）中引入所需变化，包括碱基的添加、删除、点突变等。</p>
        <p class="desc">定点突变能迅速、高效的提高DNA所表达的目的蛋白的性状及表征，是基因研究工作中一种非常有效的手段。</p>
      </div>
      <!-- 服务内容 -->
      <div class="container">
        <en-title title="服务内容" enTitle="Service Details"></en-title>
        <gene-detail-table :tableColumn="tableColumn" :tableData="tableData" :tableSpanMethod="tableSpanMethod"></gene-detail-table>
      </div>
      <!-- 交付结果 -->
      <div class="container">
        <en-title title="交付结果" enTitle="Deliverables"></en-title>
        <gene-deliverables :products="products" :reports="reports"></gene-deliverables>
      </div>
      <!-- 订购与咨询 -->
      <div class="container">
          <new-consult type="gene" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread"
import GeneTopBanner from "./gene-components/geneTopBanner"
import EnTitle from '@/components/EnTitle'
import GeneAdvantages from './gene-components/geneAdvantages'
import GeneDetailTable from './gene-components/geneDetailTable'
import GeneDeliverables from './gene-components/geneDeliverables'
export default {
  components:{
    bread, 
    GeneTopBanner,
    EnTitle,
    GeneAdvantages,
    GeneDetailTable,
    GeneDeliverables,
  },
  data () {
    return {
      smallTitle:'全基因组合成',
      bigTitle:'定点突变',
      tableColumn:[
        {
          label:'基因长度',
          prop:'geneLength',
        },
        {
          label:'生产周期（工作日）',
          prop:'productionCycle',
        },
        {
          label:'载体',
          prop:'carrier',
        }
      ],
      tableData:[
        {
          geneLength:'< 3 kb',
          productionCycle:'7 - 10',
          carrier:'客户指定载体',
        },
        {
          geneLength:'3 kb - 5 kb',
          productionCycle:'10 - 12',
        },
        {
          geneLength:'5 kb - 7 kb',
          productionCycle:'12 - 15',
        },
        {

          geneLength:'> 7 kb',
          productionCycle:'需要评估',
        },
      ],
      products:'冻干质粒 DNA 一管 ( 高拷贝约4 μg/ 管，低拷贝1-4 μg/ 管 )\n含有重组质粒的穿刺菌一管',
      reports:'测序图谱 (.abl 文件 )\n目标序列 (.seq 文件 )\nCOA 文件'
    }
  },
  methods: {
    tableSpanMethod({ row, column, rowIndex, columnIndex }){   

      if (columnIndex === 2) {
        return {
          rowspan: row.carrier ? 4 : 0,
          colspan: row.carrier ? 1 : 0
        }
      }
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Fixed-mutation.vue